import React from 'react';
import { Section } from '@atlaskit/side-navigation';
import { getAllVisibleMetrics } from '@atlassian/jira-admin-pages-performance';
import { useIntl } from '@atlassian/jira-intl';
import {
	MenuItem,
	TitleHeader,
	matchUrlPathname,
} from '@atlassian/jira-navigation-apps-sidebar-common';

import messages from './messages';

export const PerformanceAndScaleMenu = () => {
	const { formatMessage } = useIntl();

	const basePerformanceUrl = '/jira/settings/system/performance';

	const allVisibleMetrics = getAllVisibleMetrics();

	return (
		<>
			<TitleHeader>{formatMessage(messages.title)}</TitleHeader>
			<Section>
				<MenuItem
					analytics={{ itemId: 'performance-overview' }}
					selectedOn={matchUrlPathname()}
					href={`${basePerformanceUrl}/overview`}
				>
					{formatMessage(messages.overview)}
				</MenuItem>
			</Section>
			{allVisibleMetrics.length > 0 && (
				<Section title={formatMessage(messages.allReports)}>
					{allVisibleMetrics.map((metric) => (
						<MenuItem
							analytics={{ itemId: `performance-metric-${metric.key}` }}
							href={`${basePerformanceUrl}/metric/${metric.key}`}
							selectedOn={matchUrlPathname()}
							key={metric.key}
						>
							{formatMessage(metric.name)}
						</MenuItem>
					))}
				</Section>
			)}
		</>
	);
};
